import { ArrowCircleDown, ArrowCircleUp } from '@mui/icons-material'
import { IconButton } from '@mui/material'
import { useEffect, useRef, useState } from 'react'
import styled from 'styled-components'
import { SimpleScoreTitle } from '../../../models/Enums'
import { Inventory } from '../../../models/Inventory'
import { RootState, useAppDispatch, useAppSelector } from '../../../store'
import { axiosPost } from '../../Common/Axios'
import ProgressChart from '../../Common/Chart/ProgressChart'
import RangeChart from '../../Common/Chart/RangeChart'
import TextAreaDiv from '../../Common/TextAreaDiv'
import Popup from '../../Popup/Popup'
import InventoryReplyForm, {
  InventoryReplyFormValues,
} from '../../Popup/InventoryReplyForm'
import { User } from '../../../models/User'
import RemoveCircleOutlineIcon from '@mui/icons-material/RemoveCircleOutline'
import ThumbUpOffAltIcon from '@mui/icons-material/ThumbUpOffAlt'
import {
  updateInventoryMemo,
  updateInventoryPoint,
} from '../../../store/mainSlice'
import { unregisterInventory } from '../../Common/CommonApi'

type Prop = {
  inventory: Inventory
  inventories: Inventory[]
  //setInventories: (inventories: Inventory[]) => void
  payMin: number
  payMax: number
  pointMax: number
  likeMax: number
  recommendMax: number
  isShowMemo: boolean
  user: User
}

function MenteeInventoryListItem(props: Prop) {
  const [open, setOpen] = useState(false)
  const [like, setLike] = useState(0)
  const [memo, setMemo] = useState('')
  const [isMemoEdit, setIsMemoEdit] = useState(false)

  const memoInput = useRef<HTMLTextAreaElement>(null)

  const me = useAppSelector((state: RootState) => state.user.me)

  const scoreIndex: number[] = [1, 5, 7, 9, 11, 13, 15]
  const backColor: string[] = [
    '#5959ef',
    '#5959ef',
    '#5959ef',
    '#f7ac2e',
    '#f7ac2e',
    '#f7ac2e',
    '#fb7218',
    '#fb7218',
    '#fb7218',
  ]

  const dispatch = useAppDispatch()
  useEffect(() => {
    setLike(props.inventory.likeCnt)
  }, [])

  useEffect(() => {
    setMemo(props.inventory.memo)
  }, [props.inventory])

  const updateMemo = async (inventory: Inventory, value: string) => {
    const payload = {
      userId: inventory.userId.toString(),
      inventoryId: inventory.id.toString(),
      memo: value,
    }

    const result = await axiosPost('/api/inventory/update_memo', payload)
    if (result !== 'success') {
      return
    }

    // [inventory change]
    dispatch(
      updateInventoryMemo({
        inventoryId: props.inventory.id,
        memo: value,
      })
    )
    // const newInventory = { ...props.inventory, memo: value }
    // props.setInventories(
    //   props.inventories.map((inv) =>
    //     inv.id === newInventory.id ? newInventory : inv
    //   )
    // )
  }

  const handleAddLikePoint = async (inventory: Inventory, isAdd: boolean) => {
    console.log('handleAddLikePoint', inventory, isAdd)
  }

  const handleAddPoint = async (inventory: Inventory, value: number) => {
    let newValue = props.inventory.point + value
    if (newValue < 0) {
      newValue = 0
    }

    const payload = {
      userId: inventory.userId,
      inventoryId: inventory.id,
      point: newValue,
    }

    const result = await axiosPost('/api/inventory/update_point', payload)
    if (result !== 'success') {
      return
    }

    // [inventory change]
    dispatch(
      updateInventoryPoint({
        inventoryId: props.inventory.id,
        point: newValue,
      })
    )
  }

  const handleRemoveFromInventory = async () => {
    if (
      !confirm(`${props.inventory.job.name}을 인벤토리에서 삭제하시겠습니까?`)
    ) {
      return
    }

    await unregisterInventory(
      props.inventory.job.id,
      props.inventory.userId,
      dispatch
    )
  }

  const onSubmitReply = async (values: InventoryReplyFormValues) => {
    console.log(values)
  }

  return (
    <Container>
      {/* <Link to={'/job/' + props.inventory.job.id}> */}
      <Popup open={open} setOpen={setOpen} isTopCenter={false}>
        <InventoryReplyForm
          onSubmitReply={onSubmitReply}
          inventory={props.inventory}
          inventories={props.inventories}
          //setInventories={props.setInventories}
          user={props.user}
        />
      </Popup>

      <img onClick={() => setOpen(true)} src={props.inventory.job.photo} />

      <RemoveIconButton onClick={() => handleRemoveFromInventory()}>
        <RemoveCircleOutlineIcon
          style={{
            backgroundColor: 'white',
            borderRadius: '50%',
          }}
        />
      </RemoveIconButton>

      <Information>
        <div>{props.inventory.job.name}</div>
        <Content>
          <Progresses1>
            <div>만족도</div>
            <ProgressChart
              barColor="tomato"
              value={props.inventory.job.satisfaction}
              unit="%"
              align="center"
              minValue={0}
              maxValue={100}
              height={30}
              border={true}
            />
            <div>
              임금 : {props.inventory.job.payLower.toLocaleString()}만원 ~{' '}
              {props.inventory.job.payUpper.toLocaleString()}만원
            </div>
            <RangeChart
              minRange={parseInt(process.env.REACT_APP_PAY_MIN ?? '1000')}
              maxRange={parseInt(process.env.REACT_APP_PAY_MAX ?? '17000')}
              minValue={props.inventory.job.payLower}
              maxValue={props.inventory.job.payUpper}
              color="blue"
            />
            <Point>
              {me.id === props.inventory.userId ? '내점수' : '본인점수 : '}
              {me.id === props.inventory.userId && props.isShowMemo ? ( // isShowMemo=true이면 Grid가 아닌 List형태이고 List 에서만 값을 변경할 수 있음
                <>
                  <IconButton
                    onClick={() => handleAddPoint(props.inventory, -1)}
                  >
                    <ArrowCircleDown />
                  </IconButton>
                  <span>{props.inventory.point.toLocaleString()}</span>
                  <IconButton
                    onClick={() => handleAddPoint(props.inventory, 1)}
                  >
                    <ArrowCircleUp />
                  </IconButton>
                </>
              ) : (
                <span>{props.inventory.point.toLocaleString()}</span>
              )}
            </Point>
            <ProgressChart
              barColor="green"
              value={props.inventory.point}
              align="center"
              unit="점"
              minValue={0}
              maxValue={props.pointMax}
              height={10}
              border={true}
            />
            <Point>
              좋아요 :{' '}
              {me.id !== props.inventory.userId && props.isShowMemo ? ( // isShowMemo=true이면 Grid가 아닌 List형태이고 List 에서만 값을 변경할 수 있음
                <>
                  <IconButton
                    onClick={() => handleAddLikePoint(props.inventory, true)}
                  >
                    <ThumbUpOffAltIcon />
                    {/* <ThumbUpAltIcon /> */}
                  </IconButton>

                  <span>{props.inventory.likeCnt.toLocaleString()}</span>
                </>
              ) : (
                <span>{props.inventory.likeCnt.toLocaleString()}</span>
              )}
            </Point>
            <ProgressChart
              barColor="darkseagreen"
              value={props.inventory.likeCnt}
              unit="점"
              align="center"
              minValue={0}
              maxValue={props.likeMax}
              height={10}
              border={true}
            />
            <Point>
              <div>
                친구/멘토 추천 :{' '}
                <span>{props.inventory.recommendCnt.toLocaleString()}</span>
              </div>
              <div>
                댓글 : <span>{props.inventory.replyCnt.toLocaleString()}</span>
              </div>
            </Point>
            {/* <ProgressChart
              barColor="lightseagreen"
              value={props.inventory.recommendCnt}
              unit="점"
              align="center"
              minValue={0}
              maxValue={props.recommendMax}
              height={10}
              border={true}
            /> */}
          </Progresses1>
          <Score>
            <div>능력/지식/성격 요소</div>
            <div>
              {scoreIndex.map((i) => (
                <ScoreCode key={i}>
                  <div>{SimpleScoreTitle[i]}</div>
                  <div>
                    {props.inventory.job.scores[i * 5]?.scoreCode.name ?? ''}
                  </div>
                </ScoreCode>
              ))}
            </div>
          </Score>
          {props.isShowMemo && (
            <Memo>
              <div>내 메모</div>
              <TextAreaDiv100
                initialValue={props.inventory.memo}
                initialEditMode={false}
                setValue={(memo: string) => updateMemo(props.inventory, memo)}
                height="140px"
              />
            </Memo>
          )}
        </Content>
      </Information>
    </Container>
  )
}

const Container = styled.div`
  position: relative;
  display: flex;
  flex-direction: row;
  background: #f5f5f5;
  border: 1px solid #eee;
  img {
    width: 329px;
    height: 329px;
    cursor: pointer;

    @media (max-width: 768px) {
      width: 100%;
    }
  }
  @media (max-width: 768px) {
    flex-direction: column;
    width: 100%;
  }
`

const Information = styled.div`
  display: flex;
  flex-direction: column;
  padding: 10px 30px 0;

  & > div:nth-child(1) {
    font-size: 1.2rem;
    font-weight: 600;
    padding-bottom: 10px;
  }

  @media (max-width: 768px) {
    padding: 10px;
    //width: 100%;
  }
`
const Content = styled.div`
  display: flex;
  flex-direction: row;
  @media (max-width: 768px) {
    flex-direction: column;
    row-gap: 20px;
  }
  column-gap: 20px;
`

const Progresses1 = styled.div`
  width: 350px;
  /* height: 32px; */
  font-size: 1rem;
  font-weight: normal;

  // 임금 위
  & > div:nth-child(3) {
    padding-top: 10px;
  }
  // 내점수 위
  & > div:nth-child(5) {
    margin-top: -12px;
  }
  // 내점수 막대 위
  & > div:nth-child(6) {
    margin-top: -10px;
  }
  // 좋아요 위
  & > div:nth-child(7) {
    padding-top: 20px;
  }
  // 좋아요 막대 위
  & > div:nth-child(8) {
    margin-top: 0px;
  }

  // 친구 멘토 추천 위
  & > div:nth-child(9) {
    padding-top: 20px;
  }

  @media (max-width: 768px) {
    // 임금 위
    & > div:nth-child(3) {
      padding-top: 30px;
    }
    // 임금 아래
    & > div:nth-child(4) {
      padding-top: 10px;
    }
    // 내점수 위
    & > div:nth-child(5) {
      padding-top: 30px;
    }
  }
`
const Point = styled.div`
  padding-top: 10px;
  display: flex;
  flex-direction: row;
  & > button {
    padding-top: 0;
  }

  & > div {
    padding-right: 30px;
  }
`
const Score = styled.div`
  width: 280px;
  padding-left: 30px;

  @media (max-width: 768px) {
    padding-left: 0;
    padding-top: 20px;
  }
`

const ScoreCode = styled.div`
  display: flex;
  flex-direction: row;
  padding-top: 10px;
  column-gap: 10px;

  div:nth-child(1) {
    width: 80px;
    text-align: center;
    background-color: #7474a0;
    color: white;
  }
  div:nth-child(2) {
  }
`

const Memo = styled.div`
  width: 300px;
  button {
    margin-top: 0;
  }
  @media (max-width: 768px) {
    width: 100%;
    padding-top: 20px;
    box-sizing: border-box;
  }
`
const RemoveIconButton = styled(IconButton)`
  position: absolute !important;
  right: 0;
  top: 0;
  @media (max-width: 768px) {
    background-color: white;
    right: 10px;
  }
`

const TextAreaDiv100 = styled(TextAreaDiv)`
  width: 100%;
`

export default MenteeInventoryListItem
